function isEditableTarget(target) {
  return ['INPUT', 'TEXTAREA', 'SELECT'].includes(target?.tagName)
}

export function getCanvasShortcutAction(e, { selectedCount, copyBufferCount, pendingMove, pendingTransform }) {
  if (isEditableTarget(e.target)) return null
  const hasPendingOperation = !!pendingMove || !!pendingTransform

  if (e.ctrlKey && !e.shiftKey && (e.key === 'z' || e.key === 'Z' || e.code === 'KeyZ')) return 'undo'
  if (e.ctrlKey && e.shiftKey && (e.key === 'z' || e.key === 'Z' || e.code === 'KeyZ')) return 'redo'
  if ((e.key === 'Backspace' || e.key === 'Delete') && selectedCount > 0) return 'erase'

  if (!e.ctrlKey && !e.shiftKey && e.code === 'KeyM' && selectedCount > 0 && !hasPendingOperation) return 'startMove'
  if (!e.ctrlKey && !e.shiftKey && e.code === 'KeyC' && selectedCount > 0 && !hasPendingOperation) return 'startCopy'
  if (!e.ctrlKey && !e.shiftKey && e.code === 'KeyV' && copyBufferCount > 0 && !pendingMove) return 'startPaste'
  if (!e.ctrlKey && !e.shiftKey && e.code === 'KeyX' && selectedCount > 0) return 'explode'
  if (!e.ctrlKey && !e.shiftKey && e.code === 'KeyJ' && selectedCount >= 2) return 'join'
  if (!e.ctrlKey && !e.shiftKey && e.code === 'KeyR' && selectedCount > 0 && !pendingMove && !pendingTransform) return 'startRotate'
  if (e.code === 'Space' && selectedCount > 0 && !pendingMove && !pendingTransform) return 'cycleMirror'
  if (e.key === 'Escape') return 'escape'

  return null
}
